import {
  Directive,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { Subject, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ICoordinatesEvent } from './color-picker.type';

@Directive({
  selector: '[bixi-coordinates]'
})
export class BixiCoordinatesDirective implements OnInit, OnDestroy {
  @Output()
  coordinatesChange = new Subject<ICoordinatesEvent>();
  private mousechange = new Subject<{
    x: number;
    y: number;
    $event: NzSafeAny;
    isTouch: boolean;
  }>();

  private mouseListening = false;
  private subscription = Subscription.EMPTY;
  @HostListener('window:mousemove', ['$event', '$event.pageX', '$event.pageY'])
  @HostListener('window:touchmove', [
    '$event',
    '$event.touches[0].clientX',
    '$event.touches[0].clientY',
    'true'
  ])
  mousemove($event: Event, x: number, y: number, isTouch = false) {
    if (this.mouseListening) {
      $event.preventDefault();
      this.mousechange.next({ $event, x, y, isTouch });
    }
  }
  @HostListener('window:mouseup')
  @HostListener('window:touchend')
  mouseup() {
    this.mouseListening = false;
  }
  @HostListener('mousedown', ['$event', '$event.pageX', '$event.pageY'])
  @HostListener('touchstart', [
    '$event',
    '$event.touches[0].clientX',
    '$event.touches[0].clientY',
    'true'
  ])
  mousedown($event: Event, x: number, y: number, isTouch = false) {
    $event.preventDefault();
    this.mouseListening = true;
    this.mousechange.next({ $event, x, y, isTouch });
  }

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.subscription = this.mousechange
      .pipe(
        distinctUntilChanged((p, q) => p.x === q.x && p.y === q.y)
      )
      .subscribe(n => this.onChange(n.x, n.y, n.$event, n.isTouch));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onChange(x: number, y: number, $event: Event, isTouch: boolean) {
    const width = this.el.nativeElement.clientWidth;
    const height = this.el.nativeElement.clientHeight;
    const left =
      x -
      (this.el.nativeElement.getBoundingClientRect().left + window.pageXOffset);
    let top = y - this.el.nativeElement.getBoundingClientRect().top;

    if (!isTouch) {
      top = top - window.pageYOffset;
    }
    this.coordinatesChange.next({
      x,
      y,
      top,
      left,
      width,
      height,
      $event
    });
  }
}
